/** Large avatar beside a heading bar: the pairing that opens a profile page. */

import { StyleSheet, View } from 'react-native';

import { BaseSkeleton } from './base-skeleton';
import { TextContainerSkeleton } from './text-container-skeleton';

// Sized to `<ProfilePhoto type='huge'>` beside a `<Heading type='large'>`, the
// pairing that opens a profile page.
export function AvatarHeadingSkeleton() {
    return (
        <View style={AvatarHeadingSkeletonStyle.container}>
            <BaseSkeleton borderRadius={40} height={80} marginRight={8} width={80} />
            <TextContainerSkeleton borderRadius={2} height={10} width={180} />
        </View>
    );
}

const AvatarHeadingSkeletonStyle = StyleSheet.create({
    container: { flexDirection: 'row', alignItems: 'center' },
});
